<template lang="html">
  <div
    :class="deliveryParcelItem.deliveryOrderStatus === 2 && !goodsChangingOrRefunding && !threeMerchant ? 'order-tfooter clearfix prelative' : 'order-tfooter clearfix'"
  >
    <!-- v-if parcelNum > 0 包裹数量 -->
    <!-- 【查看物流入口 start 】-->
    <div
      v-if="deliveryParcelItem.parcelNum"
      class="prelative"
      @mouseenter="fetchLogisticsInfo(deliveryParcelItem)"
      @mouseleave="hideDialog()"
    >
      <div class="btn-theme-w78">
        {{TLang('查看物流','list')}}
      </div>
      <!-- 配送运单包裹信息 -->
      <deliveryInfoList
        :show="show"
        :parcelList="parcelList"
      />
    </div>
    <!-- 【查看物流入口 end 】-->
    <!-- 【查看运单退款入口 start 】-->
    <div
      v-if="!orderInfo.orderAllRefund && (deliveryParcelItem.deliveryOrderStatus === 2||deliveryParcelItem.deliveryOrderStatus === 3) && !goodsChangingOrRefunding && deliveryParcelItem.cancel && !deliveryParcelItem.onCallCancel && !deliveryParcelItem.thirdAfterFlag"
      class="btn-empty-theme-w78"
      style="line-height: 21px; position: absolute; top: 24px; left: 24px;"
      @click="() => {
        // if(timesCardPayment)title=timesTitle;
        refundDeliveryItem = deliveryParcelItem;
        confirmDialog = !confirmDialog;
      }"
    >
      {{ TLang('申请退款','list') }}
    </div>
    <div
      v-if="(deliveryParcelItem.deliveryOrderStatus === 2||deliveryParcelItem.deliveryOrderStatus === 3) && !goodsChangingOrRefunding && deliveryParcelItem.cancel && deliveryParcelItem.onCallCancel"
      class="btn-empty-theme-w78"
      style="line-height: 21px; position: absolute; top: 24px; left: 24px;"
      @click="() => {
        isShowFuXingTip = !isShowFuXingTip;
      }"
    >
      {{ TLang('联系客服','list') }}
    </div>
    <!-- 【查看运单退款入口 end 】-->
    <div class="order-tfooter-item">
      <div
        style="margin-bottom: 10px;"
      >
        <!-- <span class="font-c666" v-if="deliveryParcelItem.deliveryWay===1">
          {{ TLang('期望送达时间','orderConfirm') }}
        </span>
        <span class="font-c666" v-else-if="deliveryParcelItem.deliveryWay===2">
          {{ TLang('配送时间','orderConfirm') }}
        </span>
        <span class="font-c666" v-else-if="deliveryParcelItem.deliveryWay===3">
          {{ deliveryParcelItem.arrivalTimeFlag === "Y"? TLang('期望送达时间','orderConfirm'):TLang('期望发货时间','orderConfirm') }}
        </span> -->
        <span class="font-c666">
          {{ TLang('配送服务','orderConfirm') }}:
        </span>
        <span :class="['text', getColorClass(deliveryParcelItem) ]">
          <!-- {{ getDeliverText(deliveryParcelItem) }} -->
          <!-- {{ TLang(deliveryParcelItem.expectDeliveryText,'orderConfirm') }}{{deliveryParcelItem.deliveryWay===2 ? TLang('配送','orderConfirm') : ''}} -->
          {{ getDeliverText(deliveryParcelItem) }}
          <DeliveryTip
            v-if="deliveryParcelItem.deliveryWay == 3 && deliveryParcelItem.deliveryStyle == 2"
            :showFlag="true"
            :type="'deliveryInfo'"
            :desc="TLang('DeliveryTimeTips3', 'orderConfirm')"
          ></DeliveryTip>
        </span>
      </div>
      <!-- <div>
        <span class="font-c666">
          {{ TLang('配送方式','orderConfirm') }}
        </span>
        <span class="text">
          {{ TLang(deliveryParcelItem.deliveryWayName,'orderConfirm') }}
        </span>
      </div> -->
    </div>
    <div
      v-if="isShowPrice===1"
      class="order-tfooter-item mt-12"
    >
      <span
        class="font-c666"
      >（{{ deliveryParcelItem.freight > 0 ? ReplaceText('XXX', Number(deliveryParcelItem.freight * union_scale).toFixed(2), TLang('含运费', 'orderConfirm')) : TLang('已免运费','orderConfirm') }}）
        {{ TLang('totalProduct1','orderConfirm') }}
        <em class="font-s14">{{ deliveryParcelItem.goodsNum }}</em>
        {{ TLang('totalProduct2','orderConfirm') }}<span
          v-if="isShowPrice===1"
          style="width: auto;"
        >，{{ TLang('小计','orderConfirm') }}:
        </span>
      </span>
      <span v-if="isShowPrice===1">
        <img
          v-if="orderInfo && orderInfo.groupItem !== 'Y'"
          :src="union_icon || require('@assets/images/fudou.png')"
          alt="fudou"
          class="fudou-15"
        />
        <em class="text-num-bold-c111">{{showRmbSymbol('&#65509;')}}{{
          (parseFloat(Number(deliveryParcelItem.totalPrice * union_scale)) + parseFloat(Number(deliveryParcelItem.freight * union_scale))).toFixed(2)
        }}</em>
      </span>
      <span v-else></span>
    </div>
    <confirm-dialog
      :img="require('@assets/images/order/cancel_delivery.png')"
      :title="!timesCardPayment ? title : ''"
      :confirmBtnText="TLang('确认','address')"
      :cancelBtnText="TLang('再想想','address')"
      :description="timesCardPayment ? timesTitle : ''"
      @onCancelDialog="confirmDialog = !confirmDialog"
      @onConfirmDialog="onCancelDelivery"
    ></confirm-dialog>
    <el-dialog
      :title="TLang('联系客服','list')"
      :visible.sync="isShowFuXingTip"
      :close="() => {
        isShowFuXingTip = !isShowFuXingTip;
      }"
      width="420px"
      top="35vh"
      :center="true"
      custom-class="fuXingTip"
    >
      <p class="description" v-if="union == 'nyushanghai' && (df_lang && df_lang == 'en-US' || union_isBilingual)">客服电话: 400 618 2999-1（请忽略按1的提示音内容，直接按1咨询即可） 周一至周五 09:00-18:00</p>
      <p class="description" v-else>
        {{TLang('客服电话请忽略按的提示音内容','list')}}
      </p>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <!-- <el-button
          type="primary"
          @click="() => {
            isShowFuXingTip = !isShowFuXingTip;
          }"
        >确认</el-button> -->
        <div
          class="confirmBtn"
          @click="() => {
            isShowFuXingTip = !isShowFuXingTip;
          }"
        >{{TLang('确认','orderConfirm')}}</div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import DeliveryTip from "../components/dfTip";
import ConfirmDialog from "@components/confirmDialog";
import deliveryInfoList from "../deliveryInfoList";
import Toast from "@components/simpleToast";
import { mapActions, mapState } from "vuex";
import Cookies from "js-cookie";
import { unionFlag, formatDayTime } from "../../../../utils";
export default {
  name: "DeliveryParcelItem",
  components: {
    deliveryInfoList,
    ConfirmDialog,
    DeliveryTip,
  },
  props: {
    orderInfo: Object,
    deliveryParcelItem: null,
    deliveryParcelIndex: Number,
    isShowPrice: Number,
  },
  data() {
    return {
      show: false,
      currentDeliveryNo: 0,
      confirmDialog: false,
      isShowFuXingTip: false,
      refundDeliveryItem: null, // 当前取消的运单
      title: this.TLang("您要申请退款吗", "orderConfirm"),
      timesTitle: this.TLang("您使用的次卡继续退款申请吗", "orderConfirm"),
      df_lang: Cookies.get("df_lang"),
      union: unionFlag(),
    };
  },
  computed: {
    ...mapState("orderDetail", [
      "timesCardPayment",
      "goodsChangingOrRefunding",
      "threeMerchant",
    ]),
    ...mapState("logistics", ["parcelList"]),
  },
  watch: {
    parcelList(val) {
      val = val || [{}];
      this.show = val[0].deliveryOrderNo === this.currentDeliveryNo;
    },
  },
  methods: {
    ...mapActions("logistics", [
      "getLogisticsListForOrderDetail",
      "getLogistics",
    ]),
    ...mapActions("orderDetail", ["cancelDelivery"]),
    fetchLogisticsInfo(item) {
      const { deliveryOrderNo, parcelNum } = item;
      this.currentDeliveryNo = deliveryOrderNo;
      if (parcelNum > 1) {
        this.getLogisticsListForOrderDetail({ deliveryOrderNo });
      } else {
        this.getLogistics({ deliveryOrderNo });
      }
    },
    hideDialog() {
      this.show = false;
    },
    // 是否显示人民币符号¥或者元
    showRmbSymbol(union){
      let unionName = '';
      // 福拼拼
      if(this.orderInfo && this.orderInfo.groupItem === 'Y'){
        if(this.orderInfo.groupItemShowRmbSymbol === 'Y'){
          unionName = union;
        }
      }
      return unionName;
    },
    // 获取配送时间颜色class
    getColorClass(deliveryParcelItem) {
      let cls = '';
      if (this.orderInfo.orderStatus > 1) {
        cls = 'fontBlack';
      } else if (deliveryParcelItem.deliveryWay == 3 && deliveryParcelItem.deliveryStyle == 2) {
        // 指定日期新配送方式 deliveryStyle(配送样式：1：保持现状；2：预计发货时间)
        cls = 'fontBlue';
      } else if (deliveryParcelItem.deliveryWay == 1 || (deliveryParcelItem.deliveryWay == 3 && deliveryParcelItem.arrivalTimeFlag == 'Y')) {
        cls = 'fontBlue';
      } else if (deliveryParcelItem.deliveryWay == 3 && deliveryParcelItem.arrivalTimeFlag == 'N'){
        cls = 'fontOrange';
      }
      return cls;
    },
    // 获取配送时间展示文案
    getDeliverText(deliveryParcelItem) {
      let str = '';
      if (deliveryParcelItem.deliveryWay===1) {
        // 精准配送时间为年月日+时间段，需提取年月日转换为中文
        let preFixText = formatDayTime(deliveryParcelItem.expectDeliveryText.substring(0,10), 'ch', true);
        let suffixText = deliveryParcelItem.expectDeliveryText.substring(10, 22);
        str = `${TLang(deliveryParcelItem.deliveryWayName,'orderConfirm')} ` + preFixText + suffixText;
      } else if (deliveryParcelItem.deliveryWay===3) {
        // 指定日期新配送方式 deliveryStyle(配送样式：1：保持现状；2：预计发货时间)
        if (deliveryParcelItem.deliveryStyle == 2 && deliveryParcelItem.shipmentTime) {
          str = TLang('预计', 'address') + formatDayTime(deliveryParcelItem.shipmentTime, 'ch', true) + TLang('发货','orderConfirm');
        }
        // arrivalTimeFlag Y 期望发货时间
        else if (deliveryParcelItem.arrivalTimeFlag == 'Y') {
          str = TLang('期望', 'address') + formatDayTime(deliveryParcelItem.expectDeliveryText, 'ch', true) + TLang('送达','orderConfirm');
        } else {
          str = TLang('期望', 'address') + formatDayTime(deliveryParcelItem.expectDeliveryText, 'ch', true) + TLang('发货','orderConfirm');
        }
      } else if (deliveryParcelItem.deliveryWay===2) {
        str = TLang(deliveryParcelItem.expectDeliveryText,'orderConfirm') + TLang('配送','orderConfirm');
      }
      return str;
    },
    onCancelDelivery() {
      const { refundDeliveryItem } = this;
      let customname = "deliveryOrderNo";
      if (this.timesCardPayment) {
        customname = "orderNo";
      }
      this.cancelDelivery({
        [customname]: this.timesCardPayment
          ? this.orderInfo.orderNo
          : refundDeliveryItem.deliveryOrderNo,
        deliveryOrderCancelRemark: this.TLang("用户端取消", "orderConfirm"),
        cancelAll: this.timesCardPayment, //	组合商品，次卡支付全部取消为true, 默认false
        isPhP: false,
      })
        .then((res) => {
          if (res && res.msg) {
            this.confirmDialog = !this.confirmDialog;
            Toast.info(res.msg, 1.5);
            this.$parent.$parent.initData();
          }
        })
        .catch((err) => {
          Toast.info(err, 1);
        });
    },
  },
};
</script>

<style lang="css" scoped>
.fuXingTip .confirmBtn {
  width: 70px;
  display: block;
  cursor: pointer;
  color: #fff;
  background: #3d96e2;
  border: none;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  margin: 0 auto;
  font-weight: 500;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
}
.fuXingTip .confirmBtn:hover {
  background: #409eff;
}
</style>
